import { z } from 'zod'

export const ticketsSchema = z.object({
	answer: z.string().min(4),
})
